export const iconButtonOptions =
  ({ UIVersion }) =>
  ({ isMobile }) => ({
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gap: isMobile && UIVersion === 1 ? "60px" : "20px",
    flexWrap: isMobile ? "wrap" : "nowrap",
  });

export const backButtonContainer = ({ isMobile }) => ({
  borderRight: "1px solid",
  borderColor: "grey6",
  padding: isMobile ? "0px 10px 0px 10px" : "10px 20px 10px 10px",
  position: "sticky",
  left: isMobile ? "35px" : "60px",
  background: "white",
  zIndex: 1,
});

export const wrapper = () => ({
  transform: "scale(1)",
});

export const iconImageContainer =
  ({ isSelected, background, UIVersion }) =>
  ({ isMobile }) => ({
    background: background ? background : "white",
    border: "solid",
    borderWidth: isSelected ? "2px" : "1px",
    borderColor: isSelected && !background ? "primary" : "grey5",
    borderRadius: "10000px",
    boxShadow: isSelected ? "0px 5px 10px rgba(0, 0, 0, 0.125)" : "none",
    cursor: "pointer",
    padding: "0",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    width: UIVersion === 2 && isMobile ? "40px" : "60px",
    height: UIVersion === 2 && isMobile ? "40px" : "60px",
    flexGrow: 0,
    flexShrink: 0,

    "img, svg": {
      display: "block",
    },

    "&:hover, &:focus": {
      borderColor: "primary",
    },

    position: "relative",
    "&:after": background && {
      content: '""',
      position: "absolute",
      width: "100%",
      height: "100%",
      borderRadius: "1000px",
      background:
        "linear-gradient(135deg, #000000 0%, #FFFFFF 50%, #000000 100%)",
      backgroundImage: "$",
      mixBlendMode: "multiply",
      opacity: "0.25",
      top: 0,
      left: 0,
      overflow: "hidden",
    },
  });

export const premiumOption = ({ isSelected }) => ({
  position: "fixed",
  top: "11px",
  left: "49px",
  width: "16px",
  height: "18px",
  fontFamily: "body",
  fontStyle: "normal",
  fontWeight: "400",
  fontSize: "16px",
  lineHeight: "16px",
  color: "#FFFFFF",
  borderRadius: "10px",
  background: isSelected ? "primary" : "grey5",
  overflow: "visible !important",
});

export const newColorOptions = () => ({
  position: "fixed",
  top: "48px",
  padding: "5px 10px",
  fontFamily: "body",
  fontSize: "14px",
  lineHeight: "14px",
  letterSpacing: "0.05em",
  borderRadius: "20px",
  color: "#ffffff",
  background: "#000",
  overflow: "visible !important",
});

export const subtitle = ({ isMobile }) => ({
  display: isMobile ? "none" : "block",
  position: "fixed",
  top: "117px",
  transform: "translateX(-5px)",
  fontFamily: "body",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "12px",
  textAlign: "center",
  textTransform: "uppercase",
  whiteSpace: "nowrap",
  overflow: "hidden",
  color: "#000000",
});

export const mobileColorDots = ({ colorDot }) => ({
  position: "relative",
  "&:after": {
    content: '""',
    height: "20px",
    width: "20px",
    borderRadius: "1000px",
    border: "solid 1px",
    borderColor: "grey5",
    background: colorDot,
    position: "absolute",
    bottom: "0",
    right: "0",
  },
});
